<template>
  <div
    class="SanskritCharacterCard"
    :class="{ isActive }"
    @click="_onClickSanskritCharacterCard($event)"
  >
    <img :src="image" class="SanskritCharacterCard-Image" v-if="image" />
    <div :class="Label(data)" v-if="text">
      <p type="text" class="SanskritCharacterCard-Label">{{ text }}</p>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {};
  },
  props: {
    text: String,
    image: String,
    data: String,
    isActive: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: Object,
      default: () => ({}),
    },
  },
  created () {},
  components: {},
  methods: {
    _onClickSanskritCharacterCard ($event) {
      this.$emit("click", $event);
    },
    Label (data) {
      if (data === null) {
        return "top";
      } else {
        return "label";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.SanskritCharacterCardContainer {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-gap: 10px;
}

.SanskritCharacterCard {
  min-height: 40px;
  border: 1px solid $--border-color-base; // #e0e0e0;
  box-sizing: border-box;
  border-radius: 2px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.SanskritCharacterCard-Label {
  font-size: 14px;
  font-weight: bold;
  white-space: nowrap;
}
.SanskritCharacterCard.isActive {
  /* border: 2px solid; */
  font-weight: bold;
  background: $background-blue-lighter;
  border: 1px solid $--color-primary;
}
.SanskritCharacterCard-Image {
  display: block;
  width: 50%;
}
.label {
  text-align: center;
}
.top {
  text-align: center;
  margin-top: 10px;
}
</style>
